import React, { useEffect, useState } from "react";
import Popup from "../../../components/Popups/Popup";
import SaveButton from "../../../components/Buttons/SaveButton";
import SelectListField from "../../../components/Fields/SelectListField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import { useNotifications } from "../../../contexts/notificationContext";
import { useTranslations } from "../../../contexts/translationContext";
import DataService from "../../../services/data.service";
import { BusinessPartnerPopupProps } from "../../../types/PopupProps";
import { DataResult } from "../../../types/Result";

interface ProjectBusinessPartnerModel {
    projectId: number
    businessPartnerId: number
}

const AddProjectPopup: React.FC<BusinessPartnerPopupProps> = ({ show, onHide, businessPartnerId }) => {
    const [serverErrors, setServerErrors] = useState<DataResult<ProjectBusinessPartnerModel>>({ isSuccesful: true, messages: [], data: undefined });
    const projects = useSelectListOptions('api/v1/selectlist/Projects?activeOnly=true', '-- Select project');
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<ProjectBusinessPartnerModel>({
        projectId: 0,
        businessPartnerId: businessPartnerId
    });

    function submit() {
        if (formData) {
            DataService
                .create<ProjectBusinessPartnerModel>(`api/v1/ProjectBusinessPartners`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        if (onHide)
                            onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'projectId', label: 'Project', labelSize: 2, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Add Project'} >
            <Popup.Body>
                <SelectListField {...getFieldProps('projectId')} options={projects} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton text='Add' {...getSubmitButtonProps()} />
            </Popup.Footer>
        </Popup>
    );
}
export default AddProjectPopup;